<template>
  <div id="contactTab">
    <div>
      Address
      <v-btn v-if="!isHiringmanager" :loading="saveAddressLoading" color="accent" dark class="ml-3 action-btn" @click="newAddress()">
        <v-icon>mdi-plus</v-icon></v-btn
      >
    </div>
    <v-card :class="getClass(address) + ' mt-2 pb-3'" v-for="(address, index) in addresses" :key="`address-${index}`" :disabled="saveAddressLoading">
      <div class="ml-3 mr-3">
        <v-row>
          <v-col cols="12" lg="7" md="7" sm="12" xs="12" class="pb-0">
            <v-card-title v-if="address.Id">
              <v-btn v-if="address.VerifiedOn"
                ><v-icon class="pr-2" color="success">mdi-check-circle</v-icon>Address
                {{ addresses.some((c) => !c.Id) ? index : index + 1 }} Verified</v-btn
              >
              <v-btn v-if="address.IsDefault && !address.VerifiedOn"
                ><v-icon class="pr-2" color="error">mdi-close-circle</v-icon>Address
                {{ addresses.some((c) => !c.Id) ? index : index + 1 }} Unverified</v-btn
              >
              <v-btn v-if="!address.IsDefault && !address.VerifiedOn">Address {{ addresses.some((c) => !c.Id) ? index : index + 1 }}</v-btn>
            </v-card-title>
            <v-card-title v-if="!address.Id">
              <v-btn v-if="!isHiringmanager">New address</v-btn>
            </v-card-title>
          </v-col>
          <v-col v-if="!isHiringmanager" cols="12" lg="5" md="5" sm="12" xs="12" class="text-right">
            <v-btn small icon="mdi-pencil-outline" class="mr-3 mt-5" @click="editAddress(index)" />
            <v-btn small icon="mdi-delete" class="mr-5 mt-5" @click="removeAddress(index)" />
          </v-col>
        </v-row>
        <v-card-text>
          <v-form :ref="'frmAddress' + index" lazy-validation class="form-inputs">
            <v-row>
              <v-col cols="12" md="4">
                <AutoCompleteField
                  dense
                  outlined
                  :loading="isCountryLoading"
                  :disabled="!address.IsEditing || isCountryLoading"
                  :rules="[validations.required]"
                  showRequired
                  :items="countries"
                  item-title="Name"
                  item-value="Id"
                  @change="filterCities(index)"
                  label="Country"
                  placeholder="Country"
                  v-model="address.Country"
                  @update:modelValue="resetCity(index)"
                />
              </v-col>
              <v-col cols="12" md="8">
                <TextField
                  dense
                  :disabled="!address.IsEditing"
                  :rules="[validations.required]"
                  showRequired
                  v-model="address.StreetAddress"
                  outlined
                  label="Street Address"
                  placeholder="Street Address"
                />
              </v-col>
              <v-col cols="12" md="4">
                <AutoCompleteField
                  dense
                  outlined
                  :loading="isCityLoading"
                  :disabled="!address.IsEditing || isCityLoading"
                  :rules="[validations.required]"
                  showRequired
                  :items="address.Cities"
                  item-title="name"
                  item-value="name"
                  label="City / Suburb"
                  v-model="address.Suburb"
                >
                </AutoCompleteField>
              </v-col>
              <v-col cols="12" md="4">
                <TextField
                  dense
                  :disabled="!address.IsEditing"
                  showRequired
                  :rules="[validations.required]"
                  v-model="address.State"
                  outlined
                  placeholder="State / Province / Region"
                  label="State / Province / Region"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextField
                  :disabled="!address.IsEditing"
                  dense
                  :rules="[validations.required]"
                  showRequired
                  v-model="address.Postcode"
                  outlined
                  placeholder="Postcode"
                  label="Postcode"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextField
                  placeholder="Title"
                  label="Title"
                  :disabled="!address.IsEditing"
                  :rules="[validations.required]"
                  showRequired
                  outlined
                  dense
                  v-model="address.Name"
                  persistent-hint
                  hint="For example: Home, Office and etc"
                ></TextField>
              </v-col>
              <v-col cols="12" md="4" class="align-content-center">
                <v-checkbox :disabled="!address.IsEditing" class="mt-0" label="Default address" v-model="address.IsDefault" hide-details></v-checkbox>
              </v-col>
              <v-col v-if="address.IsEditing && !isHiringmanager" class="pt-5 align-self-center text-right" cols="12">
                <v-btn @click="cancelAddressEditing(index)" class="secondary_btn mr-4">Cancel</v-btn>
                <v-btn class="primary_btn" :loading="address.Loading" @click="saveAddress(address)">Save</v-btn>
              </v-col>
              <v-col
                v-if="!address.IsEditing && !address.ShowSendCodeButton && !address.ShowVerificationField && !isHiringmanager"
                class="pt-5 align-self-center text-right"
                cols="12"
                md="4"
              >
                <v-btn class="primary_btn" :disabled="address.IsDefault" :loading="address.Loading" @click="setAddressAsDefault(index)"
                  >Set as default</v-btn
                >
              </v-col>
            </v-row>
            <v-row v-if="!isHiringmanager && address.ShowSendCodeButton" class="pt-3">
              <v-col cols="12" md="4" class="align-self-center">
                <v-row>
                  <vue-recaptcha :sitekey="siteKey" @verify="validateAddressRecaptcha" @expire="onAddressRecaptchaExpired" ref="addressRecaptcha">
                  </vue-recaptcha>
                </v-row>
              </v-col>
              <v-col cols="12" md="8" class="align-self-center text-right">
                <v-btn @click="cancelAddressEditing(index)" class="secondary_btn mr-4">Cancel</v-btn>
                <v-btn :disabled="!addressRecaptchaVerified" :loading="addressSendingCode" class="accent" @click="sendAddressCode(address)"
                  >Send Code</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-row align="center" v-if="address.ShowVerificationField" class="pl-3 pb-5">
            <v-form :ref="'frmVerifyAddress' + index" lazy-validation v-if="!isHiringmanager">
              <v-col cols="12" class="pb-0">
                <label class="input-label"> Verification Code </label>
                <v-text-field
                  dense
                  v-model="address.VerificationCode"
                  :rules="[validations.required, validations.verificationCodeMinLength]"
                  v-on:keypress="NumbersOnly"
                  outlined
                  placeholder="Verification Code"
                />
              </v-col>
            </v-form>
            <v-col v-if="!isHiringmanager" cols="12" lg="2" md="3" sm="4" xs="4" class="pt-9 align-self-center">
              <v-btn class="secondary" :loading="addressVerifyBtnLoading" @click="verifyAddress(address)">Verify</v-btn>
            </v-col>
            <v-col class="pt-6" cols="12" lg="5" md="5" sm="5" xs="5">
              <CountdownTimer
                :fromDate="address.EndTimerDate"
                :totalSeconds="2592000"
                :addressVerificaion="true"
                @finishCountdownTimer="finishAddressCountdownTimer(index)"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="address.Message">
          <v-row>
            <v-col cols="12" lg="8" md="8" sm="12" xs="12">
              <p class="pl-5 pt-4">{{ address.Message }}</p>
            </v-col>
          </v-row>
        </v-card-actions>
      </div>
    </v-card>

    <v-row class="mt-7 mb-0 pl-4"> </v-row>
    <div>
      Phone numbers
      <v-btn v-if="!isHiringmanager" :loading="savePhoneNumberLoading" color="accent" dark class="ml-3 action-btn" @click="newPhone()">
        <v-icon>mdi-plus</v-icon></v-btn
      >
    </div>
    <v-card :class="getClass(phone) + ' mt-2 pb-3'" v-for="(phone, index) in phones" :key="`phone-${index}`" :disabled="savePhoneNumberLoading">
      <div class="ml-3 mr-3">
        <v-row>
          <v-col cols="12" lg="7" md="7" sm="12" xs="12" class="pb-0">
            <v-card-title v-if="phone.Id">
              <v-btn v-if="phone.VerifiedOn"
                ><v-icon class="pr-2" color="success">mdi-check-circle</v-icon>Phone number
                {{ phones.some((c) => !c.Id) ? index : index + 1 }} Verified</v-btn
              >
              <v-btn v-if="phone.IsDefault && !phone.VerifiedOn"
                ><v-icon class="pr-2" color="error">mdi-close-circle</v-icon>Phone number
                {{ phones.some((c) => !c.Id) ? index : index + 1 }} Unverified</v-btn
              >
              <v-btn v-if="!phone.IsDefault && !phone.VerifiedOn">Phone number {{ phones.some((c) => !c.Id) ? index : index + 1 }}</v-btn>
            </v-card-title>
            <v-card-title v-if="!phone.Id && !isHiringmanager">
              <v-btn>New phone number</v-btn>
            </v-card-title>
          </v-col>
          <v-col v-if="!isHiringmanager" cols="12" lg="5" md="5" sm="12" xs="12" class="text-right">
            <v-btn small icon="mdi-pencil-outline" class="mr-3 mt-5" @click="editPhone(index)" />
            <v-btn small icon="mdi-delete" class="mr-5 mt-5" @click="removePhone(index)" />
          </v-col>
        </v-row>
        <v-card-text>
          <v-form :ref="'frmPhone' + index" lazy-validation class="form-inputs">
            <v-row>
              <v-col cols="12" lg="3" md="3" sm="12" xs="12">
                <TextField
                  :disabled="!phone.IsEditing"
                  placeholder="Title"
                  label="Title"
                  :rules="[validations.required]"
                  showRequired
                  outlined
                  dense
                  v-model="phone.Name"
                  persistent-hint
                  hint="For example: Home, Office and etc"
                ></TextField>
              </v-col>

              <v-col cols="12" lg="3" md="3" sm="12" xs="12">
                <TextField
                  :disabled="!phone.IsEditing"
                  dense
                  :rules="[validations.required, validations.phoneNumber]"
                  showRequired
                  outlined
                  v-model="phone.Phone"
                  placeholder="Mobile phone number"
                  label="Mobile phone number"
                />
              </v-col>
              <v-col cols="12" lg="3" md="3" sm="12" xs="12" class="mt-5">
                <v-checkbox :disabled="!phone.IsEditing" label="Set as default phone number" v-model="phone.IsDefault"></v-checkbox>
              </v-col>
              <v-col v-if="phone.IsEditing && !isHiringmanager" class="pt-5 align-self-center text-right" cols="12">
                <v-btn @click="cancelPhoneEditing(index)" class="secondary_btn mr-4">Cancel</v-btn>
                <v-btn class="primary_btn" :loading="phone.Loading" @click="savePhone(phone)">Save</v-btn>
              </v-col>
              <v-col
                v-if="!phone.IsEditing && !phone.ShowSendCodeButton && !phone.ShowVerificationField && !isHiringmanager"
                class="pt-5 align-self-center text-right"
                cols="12"
                lg="3"
                md="3"
                sm="12"
                xs="12"
              >
                <v-btn class="primary_btn" :disabled="phone.IsDefault" :loading="phone.Loading" @click="setPhoneAsDefault(index)"
                  >Set as default</v-btn
                >
              </v-col>
            </v-row>
            <v-row v-if="phone.ShowSendCodeButton && !isHiringmanager" class="pt-3">
              <v-col cols="12" lg="3" md="3" sm="12" xs="12" class="align-self-center">
                <v-row>
                  <vue-recaptcha :sitekey="siteKey" @verify="validatePhoneRecaptcha" @expire="onPhoneRecaptchaExpired" ref="phoneRecaptcha">
                  </vue-recaptcha>
                </v-row>
              </v-col>
              <v-col cols="12" class="align-self-center text-right">
                <v-btn @click="cancelPhoneEditing(index)" class="secondary_btn mr-4">Cancel</v-btn>
                <v-btn :disabled="!phoneRecaptchaVerified" :loading="phoneSendingCode" class="primary_btn" @click="sendPhoneCode(phone)"
                  >Send Code</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-row align="center" v-if="phone.ShowVerificationField" class="pl-3 pb-5">
            <v-form v-if="!isHiringmanager" :ref="'frmVerifyPhone' + index" lazy-validation>
              <v-col cols="12" lg="12" md="12" sm="6" xs="12" class="pb-0">
                <label class="input-label"> Verification Code </label>
                <v-text-field
                  dense
                  v-model="phone.VerificationCode"
                  :rules="[validations.required, validations.verificationCodeMinLength]"
                  v-on:keypress="NumbersOnly"
                  outlined
                  placeholder="Verification Code"
                />
              </v-col>
            </v-form>
            <v-col v-if="!isHiringmanager" cols="12" lg="2" md="3" sm="4" xs="4" class="pt-9 align-self-center">
              <v-btn class="secondary" :loading="phoneNumberVerifyBtnLoading" @click="verifyPhone(phone)">Verify</v-btn>
            </v-col>
            <v-col class="pt-6" cols="12" lg="5" md="5" sm="5" xs="5">
              <CountdownTimer
                :fromDate="phone.EndTimerDate"
                :totalSeconds="120"
                :phoneNumberVerification="true"
                @finishCountdownTimer="finishPhoneCountdownTimer(index)"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="phone.Message">
          <v-row>
            <v-col cols="12" lg="8" md="8" sm="12" xs="12">
              <p class="pl-5 pt-4">{{ phone.Message }}</p>
            </v-col>
          </v-row>
        </v-card-actions>
      </div>
    </v-card>
    <v-dialog v-if="showConfirm" v-model="showConfirm" max-width="500" @keydown.esc="showConfirm = false">
      <confirm-dialog :message="confirmModel" @confirm="confirmRemove" @cancel="cancel"></confirm-dialog>
    </v-dialog>
    <v-dialog v-if="showDefaultAddress" v-model="showDefaultAddress" max-width="500" @keydown.esc="showDefaultAddress = false">
      <confirm-dialog :message="confirmModel" @confirm="confirmDefault" @cancel="cancel"></confirm-dialog>
    </v-dialog>
    <v-dialog v-if="showDefaultPhone" v-model="showDefaultPhone" max-width="500" @keydown.esc="showDefaultPhone = false">
      <confirm-dialog :message="confirmModel" @confirm="confirmDefault" @cancel="cancel"></confirm-dialog>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { Teammember, Address, Phone } from "../../models/Teammember";
import CountdownTimer from "../Range/CountdownTimer.vue";
import Vue, { defineComponent } from "vue";
import { ProjectMessages } from "../../definitions/constants";
//import ChallengeV2 from "vue-recaptcha";
import { recaptchaSiteKey } from "../../plugins/firebase";
import ConfirmDialog from "../ConfirmDialog.vue";
import TeamMemberService from "../../services/TeamMemberService";
import validations from "../../utils/validations";
import AutoCompleteField from "../Fields/AutoCompleteField.vue";
import TextField from "../Fields/TextField.vue";
import { isAndroid } from "mobile-device-detect";

import vueRecaptcha from "vue3-recaptcha2";
import { CityModel, CountryApi, CountryModel, VerificationApi, IdentityGetStatusResponseModel } from "../../services/openApi/api";
import { identity } from "@fullcalendar/core/internal";
// import { VueReCaptcha } from 'vue-recaptcha-v3'

export interface UIAddress extends Address {
  IsEditing: boolean | false;
  ShowSendCodeButton: boolean | false;
  ShowVerificationField: boolean | false;
  Message: string | "";
  Loading: boolean | false;
  Cities: string[];
}
export interface UIPhone extends Phone {
  IsEditing: boolean | false;
  ShowSendCodeButton: boolean | false;
  ShowVerificationField: boolean | false;
  Message: string | "";
  Loading: boolean | false;
}

export default defineComponent({
  props: [
    "formLoading",
    "addressList",
    "phoneList",
    "addressSendCodeLoading",
    "phoneSendCodeLoading",
    "tmModel",
    "addressLoading",
    "phoneNumberLoading",
    "addressVerifyLoading",
    "phoneNumberVerifyLoading",
    "selectedTeammemberModel",
    "isHiringmanager",
  ],
  components: {
    //ChallengeV2,
    vueRecaptcha,
    CountdownTimer,
    ConfirmDialog,
    TextField,
    AutoCompleteField,
  },
  data() {
    return {
      validations,
      addresses: [{} as UIAddress] as UIAddress[],
      countries: [] as CountryModel[],
      phones: [{} as UIPhone] as UIPhone[],
      selectedAddress: null as UIAddress | null,
      selectedPhone: null as UIPhone | null,
      siteKey: recaptchaSiteKey,
      addressRecaptchaVerified: false,
      addressRecaptchaExpired: false,
      isCityLoading: false,
      isCountryLoading: false,
      phoneRecaptchaVerified: false,
      phoneRecaptchaExpired: false,
      teamMember: {} as Teammember,
      addressSendingCode: false,
      phoneSendingCode: false,
      saveAddressLoading: false,
      savePhoneNumberLoading: false,
      addressVerifyBtnLoading: false,
      phoneNumberVerifyBtnLoading: false,
      addressCode: "",
      phoneTimer: null as Date | null,
      phoneNumberCode: "",
      showConfirm: false,
      showDefaultAddress: false,
      showDefaultPhone: false,
      showDefault: false,
      confirmModel: {
        title: "",
        text: "",
      },
      capctahLoaded: false,
      identityImages: [] as IdentityGetStatusResponseModel[],
    };
  },
  computed: {
    isDeviceAndroid(): boolean {
      return isAndroid;
    },
    isVerified(): boolean {
      var result = true;
      this.identityImages.forEach((el) => {
        if (el.isVerified === false) {
          result = false;
          return false;
        }
      });

      return this.identityImages.length > 0 && result;
    },
  },
  methods: {
    resetCity(index: number) {
      this.addresses[index].Suburb = "";
    },
    NumbersOnly(evt: any) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getClass(item: any) {
      if (item.Id) {
        if (item.IsDefault) {
          return item.VerifiedOn ? "success-border" : "error-border";
        }
      }
      return "default-border";
    },
    async filterCities(index: any) {
      var address = this.addresses[index];
      var countryItem = this.countries.find((c: CountryModel) => c.Id === address.Country);
      if (countryItem && countryItem.Id) {
        this.isCityLoading = true;
        address.Cities = (await new CountryApi().getCities(countryItem.Id)).data.map((c: CityModel) => {
          return c.Name;
        }) as string[];
        this.isCityLoading = false;
        new CountryApi().getCities(countryItem.Id).then((response) => {
          if (response.data) {
            address.Cities = response.data?.map((c: CityModel) => {
              return c.Name;
            }) as string[];
          }
        });
      }
      return address.Cities;
    },
    setPhoneAsDefault(index: any) {
      this.selectedPhone = this.phones[index];
      var hasDefault = this.phones.some((c: any) => c.IsDefault && c.Id && c.Id != this.phones[index].Id);
      if (hasDefault) {
        this.confirmModel.title = `Seting phone number(${this.selectedPhone.Name}) as default`;
        this.confirmModel.text = ProjectMessages.setAsDefaultPhoneMessage;
        this.showDefaultPhone = true;
      } else {
        if (this.selectedPhone.Id) {
          this.startPhoneLoading(this.selectedPhone);
          this.$emit("setPhoneAsDefault", this.selectedPhone.Id);
        }
      }
    },
    setAddressAsDefault(index: any) {
      this.selectedAddress = this.addresses[index];
      var hasDefault = this.addresses.some((c) => c.IsDefault && c.Id && c.Id != this.addresses[index].Id);
      if (hasDefault) {
        this.confirmModel.title = `Seting address(${this.selectedAddress.Name}) as default`;
        this.confirmModel.text = ProjectMessages.setAsDefaultAddressMessage;
        this.showDefaultAddress = true;
      } else {
        if (this.selectedAddress.Id) {
          this.startAddressLoading(this.selectedAddress);
          this.$emit("setAddressAsDefault", this.selectedAddress.Id);
        }
      }
    },
    confirmDefault() {
      this.showDefaultAddress = false;
      this.showDefaultPhone = false;
      if (this.selectedAddress) {
        this.startAddressLoading(this.selectedAddress);
        this.$emit("setAddressAsDefault", this.selectedAddress.Id);
        this.selectedAddress = null;
      }
      if (this.selectedPhone) {
        this.startPhoneLoading(this.selectedPhone);
        this.$emit("setPhoneAsDefault", this.selectedPhone.Id);
        this.selectedPhone = null;
      }
    },
    newPhone() {
      if (this.phones) {
        var existNewPhones = this.phones.some((c) => !c.Id);
        if (existNewPhones) {
          this.$emit("snackbarMessage", {
            message: ProjectMessages.newPhoneAlert,
            type: "error",
          });
        } else {
          if (this.phones.length > 2) {
            this.$emit("snackbarMessage", {
              message: ProjectMessages.phoneLimitAlert,
              type: "error",
            });
          } else {
            var list = [...this.phones];
            var newItem = { IsEditing: true } as UIPhone;
            if (!this.phones || this.phones.length === 0) {
              newItem.Phone = this.tmModel.Phone;
            }
            list.splice(0, 0, newItem);
            this.phones = list;
          }
        }
      }
    },
    startVerification() {
      // @ts-ignore
      if (JSBridge && JSBridge.showMessageInNative) {
        // @ts-ignore
        JSBridge.showMessageInNative("startVerification");
      }
    },
    newAddress() {
      if (this.addresses) {
        var existNewAddress = this.addresses.some((c) => !c.Id);
        if (existNewAddress) {
          this.$emit("snackbarMessage", {
            message: ProjectMessages.newAddressAlert,
            type: "error",
          });
        } else {
          if (this.addresses.length > 2) {
            this.$emit("snackbarMessage", {
              message: ProjectMessages.addressLimitAlert,
              type: "error",
            });
          } else {
            var list = [...this.addresses];
            var newItem = { IsEditing: true } as UIAddress;
            if (!this.addresses || this.addresses.length === 0) {
              if (this.tmModel.Country && this.tmModel.City) {
                newItem.Country = this.tmModel.Country;
                newItem.Suburb = this.tmModel.City;
              }
            }
            list.splice(0, 0, newItem);
            this.addresses = list;
            if (!this.addresses || this.addresses.length === 1) {
              this.filterCities(0);
            }
          }
        }
      }
    },
    cancelAddressEditing(index: any) {
      this.addressRecaptchaVerified = false;
      if (this.addresses[index]) {
        if (this.addresses[index].Id) {
          var addressCopy = [...this.addresses];
          addressCopy[index].Message = "";
          addressCopy[index].ShowSendCodeButton = false;
          addressCopy[index].IsEditing = false;
          this.addresses = addressCopy;
        } else {
          this.removeAddress(index);
        }
      }
    },
    cancelPhoneEditing(index: any) {
      this.phoneRecaptchaVerified = false;
      if (this.phones[index]) {
        if (this.phones[index].Id) {
          var phoneCopy = [...this.phones];
          phoneCopy[index].Message = "";
          phoneCopy[index].ShowSendCodeButton = false;
          phoneCopy[index].IsEditing = false;
          this.phones = phoneCopy;
        } else {
          this.removePhone(index);
        }
      }
    },

    async validateAddressRecaptcha(token: any) {
      this.addressSendingCode = true;
      var result = await TeamMemberService.verifyCaptcha(token, this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
      this.addressRecaptchaVerified = result.success;
      if (result.success) {
        this.addressRecaptchaExpired = false;
      }
      this.addressSendingCode = false;
    },
    async validatePhoneRecaptcha(token: any) {
      this.phoneSendingCode = true;
      var result = await TeamMemberService.verifyCaptcha(token, this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
      this.phoneRecaptchaVerified = result.success;
      if (result.success) {
        this.phoneRecaptchaExpired = false;
      }
      this.phoneSendingCode = false;
    },
    onAddressRecaptchaExpired() {
      this.addressRecaptchaVerified = false;
      this.addressRecaptchaExpired = true;
    },
    onPhoneRecaptchaExpired() {
      this.phoneRecaptchaVerified = false;
      this.phoneRecaptchaExpired = true;
    },
    finishAddressCountdownTimer(index: any) {
      if (this.addresses) {
        var addressCopy = [...this.addresses];
        addressCopy[index].ShowVerificationField = false;
        addressCopy[index].ShowSendCodeButton = true;
        addressCopy[index].Message = ProjectMessages.verificationTimeOver;
        this.addresses = addressCopy;
      }
      this.addressRecaptchaVerified = false;
    },
    finishPhoneCountdownTimer(index: any) {
      if (this.phones) {
        var phoneCopy = [...this.phones];
        phoneCopy[index].ShowVerificationField = false;
        phoneCopy[index].ShowSendCodeButton = true;
        phoneCopy[index].Message = ProjectMessages.verificationTimeOver;
        this.phones = phoneCopy;
      }
      this.phoneRecaptchaVerified = false;
    },
    async verifyAddress(address: any) {
      var idx = address.Id ? this.addresses.findIndex((c) => c.Id === address.Id) : 0;
      var form = this.$refs["frmVerifyAddress" + idx];
      if (form) {
        const isValid = await (form as any).validate();
        if (isValid.valid) {
          this.startAddressLoading(address);
          this.$emit("verifyAddress", address);
        }
      }
    },
    async verifyPhone(phone: any) {
      var idx = phone.Id ? this.phones.findIndex((c) => c.Id === phone.Id) : 0;
      var form = this.$refs["frmVerifyPhone" + idx];
      if (form) {
        const isValid = await (form as any).validate();
        if (isValid.valid) {
          this.startPhoneLoading(phone);
          this.$emit("verifyPhone", phone);
        }
      }
    },
    sendAddressCode(address: any) {
      if (this.addressRecaptchaExpired || !this.addressRecaptchaVerified) {
        this.$emit("snackbarMessage", {
          message: ProjectMessages.emptyCaptcha,
          type: "error",
        });
      } else {
        this.startAddressLoading(address);
        this.$emit("sendAddressCode", address.Id);
      }
    },
    sendPhoneCode(phone: any) {
      if (this.phoneRecaptchaExpired || !this.phoneRecaptchaVerified) {
        this.$emit("snackbarMessage", {
          message: ProjectMessages.emptyCaptcha,
          type: "error",
        });
      } else {
        this.startPhoneLoading(phone);
        this.$emit("sendPhoneCode", phone.Id);
      }
    },
    async saveAddress(address: any) {
      var idx = address.Id ? this.addresses.findIndex((c) => c.Id === address.Id) : 0;
      var form = this.$refs["frmAddress" + idx] as any;
      if (form) {
        var isValid = await (form[0] as any).validate();
        if (isValid.valid) {
          this.startAddressLoading(address);
          this.$emit("saveAddress", address);
        } else if (!isValid) {
          var el = document.querySelector("#contactTab .v-messages.error--text:first-of-type");
          this.$emit("scrollToElement", el);
        }
      }
    },
    async savePhone(phone: any) {
      var idx = phone.Id ? this.phones.findIndex((c) => c.Id === phone.Id) : 0;
      var form = this.$refs["frmPhone" + idx] as any;
      if (form) {
        var isValid = await (form[0] as any).validate();
        if (isValid.valid) {
          this.startPhoneLoading(phone);
          this.$emit("savePhone", phone);
        } else {
          var el = document.querySelector("#contactTab .v-messages.error--text:first-of-type");
          this.$emit("scrollToElement", el);
        }
      }
    },
    removeAddress(index: any) {
      if (this.addresses[index]) {
        if (this.addresses[index].Id) {
          this.confirmModel.title = `Remove Address(${this.addresses[index].Name})`;
          this.confirmModel.text = "Are you sure?";
          this.showConfirm = true;
          this.selectedAddress = this.addresses[index];
        } else {
          this.addresses.splice(index, 1);
        }
      }
    },
    removePhone(index: any) {
      if (this.phones[index]) {
        if (this.phones[index].Id) {
          this.confirmModel.title = `Remove Phone(${this.phones[index].Name})`;
          this.confirmModel.text = "Are you sure?";
          this.showConfirm = true;
          this.selectedPhone = this.phones[index];
        } else {
          this.phones.splice(index, 1);
        }
      }
    },
    async confirmRemove(): Promise<void> {
      this.showConfirm = false;

      if (this.selectedAddress) {
        this.$emit("removeAddress", this.selectedAddress.Id);
        this.selectedAddress = null;
      }
      if (this.selectedPhone) {
        this.$emit("removePhone", this.selectedPhone.Id);
        this.selectedPhone = null;
      }
    },
    startAddressLoading(address: any) {
      var idx = this.addresses.findIndex((c) => c.Id === address.Id);
      var addressCopy = [...this.addresses];
      addressCopy[idx].Loading = true;
      this.addresses = addressCopy;
    },
    startPhoneLoading(phone: any) {
      var idx = this.phones.findIndex((c) => c.Id === phone.Id);
      var phoneCopy = [...this.phones];
      phoneCopy[idx].Loading = true;
      this.phones = phoneCopy;
    },
    cancel(): void {
      this.showConfirm = false;
      this.showDefaultAddress = false;
      this.showDefaultPhone = false;
      this.selectedAddress = null;
      this.selectedPhone = null;
    },
    async editAddress(index: any) {
      this.addressRecaptchaVerified = false;
      if (this.addresses[index]) {
        var addressCopy = [...this.addresses];
        addressCopy[index].Cities = await this.filterCities(index);
        addressCopy.forEach((c) => {
          c.ShowSendCodeButton = false;
        });
        addressCopy[index].IsEditing = true;
        this.addresses = addressCopy;
      }
    },
    editPhone(index: any) {
      this.phoneRecaptchaVerified = false;
      if (this.phones[index]) {
        var phoneCopy = [...this.phones];
        phoneCopy.forEach((c) => {
          c.ShowSendCodeButton = false;
        });
        phoneCopy[index].IsEditing = true;
        this.phones = phoneCopy;
      }
    },
    loadData(list: any, isAddress = false) {
      var nowdate = new Date();
      list.forEach((item: any, index: any) => {
        item.Message = "";
        if (isAddress) {
          item.Citiies = this.filterCities(index);
        }
        if (item.Id && item.IsDefault) {
          var timeDiff = item.EndTimerDate - nowdate.getTime();
          if (!item.EndTimerDate) {
            item.Message = isAddress ? ProjectMessages.addressSaved : ProjectMessages.phoneNumberSaved;
            item.ShowSendCodeButton = true;
            if (isAddress) {
              this.addressRecaptchaVerified = false;
            } else {
              this.phoneRecaptchaVerified = false;
            }
          } else {
            if (timeDiff <= 0) {
              item.ShowVerificationField = false;
            }
          }
          if (item.StartTimerDate && !item.VerifiedOn) {
            item.Message = isAddress
              ? ProjectMessages.addressSendingCode
              : `Thank you! We will send a verification code to ${item.Phone}. ${ProjectMessages.phoneNumberEnterVerificationCode}`;
            if (timeDiff <= 0) {
              item.ShowVerificationField = false;
              item.Message = "";
            } else {
              item.ShowVerificationField = true;
            }
          }
        } else {
          item.ShowSendCodeButton = false;
          item.ShowVerificationField = false;
        }
        item.IsEditing = false;
        item.Loading = false;
      });
      return list;
    },
  },
  watch: {
    phoneList(newVal) {
      this.phones = newVal as UIPhone[];
      this.phones = this.loadData(this.phones);
      if (!this.phones || this.phones.length === 0) {
        var list = [...this.phones];
        var newItem = { IsEditing: true, Phone: this.tmModel.Phone ? this.tmModel.Phone : "" } as UIPhone;
        list.push(newItem);
        this.phones = list;
      }
    },
    addressList(newVal) {
      this.addresses = newVal as UIAddress[];
      this.addresses = this.loadData(this.addresses, true);
      if (!this.addresses || this.addresses.length === 0) {
        var list = [...this.addresses];
        var newItem = { IsEditing: true } as UIAddress;
        if (this.tmModel.Country && this.tmModel.City) {
          newItem.Country = this.tmModel.Country;
          newItem.Suburb = this.tmModel.City;
        }
        list.push(newItem);
        this.addresses = list;
        if (newItem.Country && newItem.Suburb) {
          this.filterCities(0);
        }
      }
    },
    showPhoneVerificationField(newVal) {
      this.phoneRecaptchaVerified = false;
      this.phoneRecaptchaExpired = false;
    },
    showAddressVerificationField(newVal) {
      this.addressRecaptchaVerified = false;
      this.addressRecaptchaExpired = false;
    },
    phoneEndTimer(newVal) {
      this.phoneTimer = newVal;
    },
    addressSendCodeLoading(newVal) {
      this.addressSendingCode = newVal;
    },
    phoneSendCodeLoading(newVal) {
      this.phoneSendingCode = newVal;
    },
    formLoading(newVal) {
      this.saveAddressLoading = newVal;
      this.savePhoneNumberLoading = newVal;
    },
    addressLoading(newVal) {
      this.saveAddressLoading = newVal;
    },
    phoneNumberLoading(newVal) {
      this.savePhoneNumberLoading = newVal;
    },
    addressVerifyLoading(newVal) {
      this.addressVerifyBtnLoading = newVal;
    },
    phoneNumberVerifyLoading(newVal) {
      this.phoneNumberVerifyBtnLoading = newVal;
    },
  },
  async mounted() {
    this.isCountryLoading = true;
    this.countries = (await new CountryApi().getCountries()).data;
    this.$emit("getContact");
    this.identityImages = (await new VerificationApi().getStatus()).data;
    this.isCountryLoading = false;
  },
});
</script>

<style scoped>
.img-border {
  border-width: 3px !important;
}
</style>
